import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: '登录',
    component: Login,
    meta: {
      title: '艺小道',
    },

  },


  {
    path: '/index',
    name: 'index',
    meta: {
      title: '课程分类',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Index.vue'),
  },
  {
    path: '/list/:kecheng_category_id/:kecheng_type',
    name: 'list',
    meta: {
      title: '课程列表页',
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/List.vue'),
  },
  {
    path: '/detail/:course_id',
    name: 'detail',
    meta: {
      title: '课程详情',
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Detail.vue'),
  },
];

const router = new VueRouter({
  routes,
});


export default router;
